import { checkTranslationRegex } from './general-utils';

export const TASK_COCKPIT = 'TASK_COCKPIT';

export const canAccessTaskCockpit = (user = {}) =>
  Object.entries(user.areas || {}).some(([key, allowed]) => allowed && ['user', 'all'].includes(key.toLowerCase()));

export const landingPageOptions = (apps, allowTasks, translate) => [
  ...apps.map((app) => ({
    ...app,
    Title: checkTranslationRegex(app.Title) ? translate(app.Title) : app.Title
  })),
  ...(allowTasks ? [{ Title: translate('admin.access.users.task_cockpit'), UUID: TASK_COCKPIT }] : []),
  { Title: 'Launchpad', UUID: null }
];
